import React, { useEffect, useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate, useParams } from "react-router-dom";

// export const NotificationList = () => {
//   const [notifications, setNotifications] = useState([]);

//   // Send modal states
//   const [showSendModal, setShowSendModal] = useState(false);
//   const [selectedNotification, setSelectedNotification] = useState(null);
//   const [sendData, setSendData] = useState({
//     role: "customer",
//     user_id: ""
//   });

//   // Fetch notifications
//   const fetchData = async () => {
//     try {
//       const response = await axios.get(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_notification"
//       );

//       if (response.data.status === true) {
//         setNotifications(response.data.data || []);
//       } else {
//         toast.error("Failed to fetch notifications.");
//       }
//     } catch (error) {
//       toast.error("Something went wrong while fetching data.");
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   // Delete notification
//   const deleteNotification = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this notification?")) {
//       return;
//     }

//     try {
//       const response = await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_notification",
//         { id }
//       );

//       if (response.data.status === true || response.data.success === "1") {
//         toast.success("Notification deleted successfully!");
//         setNotifications((prev) => prev.filter((item) => item.id !== id));
//       } else {
//         toast.error("Failed to delete notification.");
//       }
//     } catch {
//       toast.error("Something went wrong while deleting notification.");
//     }
//   };

//   // Open send modal
//   const openSendModal = (notification) => {
//     setSelectedNotification(notification);
//     setSendData({ role: "customer", user_id: "" });
//     setShowSendModal(true);
//   };

//   // Send existing notification
//   const sendNotificationAgain = async () => {
//     if (
//       sendData.role === "single" &&
//       !sendData.user_id
//     ) {
//       toast.error("User ID is required");
//       return;
//     }

//     try {
//       await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/send_notification",
//         {
//           notification_id: selectedNotification.id,
//           receiver_type: sendData.role,
//           user_id:
//             sendData.role === "single"
//               ? sendData.user_id
//               : null
//         }
//       );

//       toast.success("Notification sent successfully!");
//       setShowSendModal(false);
//     } catch {
//       toast.error("Failed to send notification");
//     }
//   };

//   return (
//     <div className="page-content">
//       <div className="container-fluid">

//         {/* Page Title */}
//         <div className="row">
//           <div className="col-12">
//             <div className="page-title-box">
//               <h4 className="mb-0 fw-semibold">All Notifications</h4>
//               <ol className="breadcrumb mb-0">
//                 <li className="breadcrumb-user">
//                   <a href="#">Dashboard</a>
//                 </li>
//                 <li className="breadcrumb-user active">Notifications</li>
//               </ol>
//             </div>
//           </div>
//         </div>

//         {/* Table */}
//         <div className="row">
//           <div className="col-xl-12">
//             <div className="card">
//               <div className="card-header d-flex justify-content-between align-users-center">
//                 <h4 className="card-title">All Notification Logs</h4>
//                 <Link
//                   to="/notification-list-add"
//                   className="btn btn-sm btn-primary"
//                 >
//                   Create Notification
//                 </Link>
//               </div>

//               <div className="card-body p-0">
//                 <div className="table-responsive">
//                   <table className="table align-middle table-hover table-centered mb-0">
//                     <thead className="bg-light-subtle">
//                       <tr>
//                         <th>#</th>
//                         <th>Title</th>
//                         <th>Message</th>
//                         <th>Type</th>
//                         <th>Role</th>
//                         <th>Status</th>
//                         <th>Time</th>
//                         <th>Action</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {notifications.length > 0 ? (
//                         notifications.map((item, index) => {
//                           const isUnread = String(item.is_read) === "0";

//                           return (
//                             <tr key={item.id}>
//                               <td>{index + 1}</td>

//                               <td>{item.title}</td>
//                               <td>{item.message}</td>

//                               <td>
//                                 <span className="badge bg-info">
//                                   {item.type}
//                                 </span>
//                               </td>

//                               <td className="text-capitalize">
//                                 {item.receiver_type}
//                               </td>

//                               <td>
//                                 <span
//                                   className={`badge ${
//                                     isUnread
//                                       ? "bg-warning text-dark"
//                                       : "bg-success"
//                                   }`}
//                                 >
//                                   {isUnread ? "Unread" : "Read"}
//                                 </span>
//                               </td>

//                               <td>{item.created_at}</td>

//                               <td>
//                                 <div className="d-flex gap-2">
//                                   <Link
//                                     to={`/notification-list-view/${item.id}`}
//                                   >
//                                     <button className="btn btn-light btn-sm">
//                                       <AiOutlineEye className="fs-5" />
//                                     </button>
//                                   </Link>

//                                   <Link
//                                     to={`/notification-list-edit/${item.id}`}
//                                   >
//                                     <button className="btn btn-light btn-sm">
//                                       <i className="fa-solid fa-pencil"></i>
//                                     </button>
//                                   </Link>

//                                   {(() => {
//                                       const isAlreadySent =
//                                         item.is_sent === "1" ||
//                                         item.status === "sent" ||
//                                         item.sent_at;

//                                       return (
//                                         <button
//                                           onClick={() => openSendModal(item)}
//                                           className={`btn btn-sm ${
//                                             isAlreadySent ? "btn-warning" : "btn-soft-primary"
//                                           }`}
//                                         >
//                                           {isAlreadySent ? "Resend" : "Send"}
//                                         </button>
//                                       );
//                                     })()}

//                                   <button
//                                     onClick={() =>
//                                       deleteNotification(item.id)
//                                     }
//                                     className="btn btn-soft-danger btn-sm"
//                                   >
//                                     <i className="fa-solid fa-trash fs-18"></i>
//                                   </button>
//                                 </div>
//                               </td>
//                             </tr>
//                           );
//                         })
//                       ) : (
//                         <tr>
//                           <td
//                             colSpan="8"
//                             className="text-center text-muted py-4"
//                           >
//                             No notifications available.
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <div className="card-footer text-end">
//                 <small className="text-muted">
//                   Showing {notifications.length} entries
//                 </small>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Send Modal */}
//         {showSendModal && (
//           <div className="custom-modal-overlay">
//             <div className="custom-modal">
//               <div className="card shadow-lg border-0">

//                 {/* Header */}
//                 <div className="card-header d-flex justify-content-between align-items-center">
//                   <h5 className="mb-0">Send Notification</h5>
//                   <button
//                     className="btn-close"
//                     onClick={() => setShowSendModal(false)}
//                   />
//                 </div>

//                 {/* Body */}
//                 <div className="card-body">
//                   <div className="mb-3">
//                     <label className="form-label">Send To</label>
//                     <select
//                       className="form-select"
//                       value={sendData.role}
//                       onChange={(e) =>
//                         setSendData({
//                           ...sendData,
//                           role: e.target.value
//                         })
//                       }
//                     >
//                       <option value="customer">All Customers</option>
//                       <option value="seller">All_Sellers</option>
//                       <option value="all">All_Users</option>
//                       <option value="single">Single_User</option>
//                     </select>
//                   </div>

//                   {sendData.role === "single" && (
//                     <input
//                       className="form-control"
//                       placeholder="User ID"
//                       value={sendData.user_id}
//                       onChange={(e) =>
//                         setSendData({
//                           ...sendData,
//                           user_id: e.target.value
//                         })
//                       }
//                     />
//                   )}
//                 </div>

//                 {/* Footer */}
//                 <div className="card-footer d-flex justify-content-end gap-2 bg-light">
//                   <button
//                     className="btn btn-light"
//                     onClick={() => setShowSendModal(false)}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     className="btn btn-primary"
//                     onClick={sendNotificationAgain}
//                   >
//                     Send
//                   </button>
//                 </div>

//               </div>
//             </div>
//           </div>
// )}



//         {/* Footer */}
//         <footer className="footer mt-4 text-center">
//           <div className="container-fluid">
//             © 2025 Notification System
//           </div>
//         </footer>

//       </div>
//     </div>
//   );
// };




// export const AddNotification = () => {
//   const navigate = useNavigate();

//   const [formData, setFormData] = useState({
//     role: "customer", // customer | seller | all | single
//     user_id: "",
//     title: "",
//     message: "",
//     type: "",
//     reference_id: "",
//     reference_model: "",
//     priority: "normal",
//     action_url: ""
//   });

//   // Handle input change
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Submit notification (AUTO-SEND)
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!formData.title || !formData.message) {
//       toast.error("Please fill required fields");
//       return;
//     }

//     if (formData.role === "single" && !formData.user_id) {
//       toast.error("User ID is required for Single_User");
//       return;
//     }

//     const payload = {
//       title: formData.title,
//       message: formData.message,
//       type: formData.type,
//       reference_id: formData.reference_id,
//       reference_model: formData.reference_model,
//       priority: formData.priority,
//       action_url: formData.action_url,
//       receiver_type: formData.role,
//       user_id:
//         formData.role === "single"
//           ? formData.user_id
//           : null
//     };

//     try {
//       const response = await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_notification",
//         payload
//       );

//       if (response.data.status === true || response.data.success === "1") {
//         toast.success("Notification sent successfully!");
//         navigate("/notification-list");
//       } else {
//         toast.error("Failed to add notification");
//       }
//     } catch (error) {
//       toast.error("Something went wrong");
//     }
//   };

//   return (
//     <div className="page-content">
//       <div className="container-fluid">

//         {/* Page Title */}
//         <div className="row">
//           <div className="col-12">
//             <div className="page-title-box">
//               <h4 className="mb-0 fw-semibold">Add Notification</h4>
//               <ol className="breadcrumb mb-0">
//                 <li className="breadcrumb-user">
//                   <a href="#">Dashboard</a>
//                 </li>
//                 <li className="breadcrumb-user">
//                   <a href="#">Notifications</a>
//                 </li>
//                 <li className="breadcrumb-user active">Add</li>
//               </ol>
//             </div>
//           </div>
//         </div>

//         {/* Form */}
//         <div className="row">
//           <div className="col-xl-12">
//             <div className="card">
//               <div className="card-header">
//                 <h4 className="card-title">Create Notification</h4>
//               </div>

//               <div className="card-body">
//                 <form onSubmit={handleSubmit}>
//                   <div className="row g-3">

//                     {/* Send To */}
//                     <div className="col-md-6">
//                       <label className="form-label">Send To *</label>
//                       <select
//                         name="role"
//                         className="form-select"
//                         value={formData.role}
//                         onChange={handleChange}
//                       >
//                         <option value="customer">All Customers</option>
//                         <option value="seller">All_Sellers</option>
//                         <option value="all">All_Users</option>
//                         <option value="single">Single_User</option>
//                       </select>
//                     </div>

//                     {/* User ID (only for Single_User) */}
//                     {formData.role === "single" && (
//                       <div className="col-md-6">
//                         <label className="form-label">User ID *</label>
//                         <input
//                           type="text"
//                           name="user_id"
//                           className="form-control"
//                           value={formData.user_id}
//                           onChange={handleChange}
//                         />
//                       </div>
//                     )}

//                     {/* Title */}
//                     <div className="col-md-6">
//                       <label className="form-label">Title *</label>
//                       <input
//                         type="text"
//                         name="title"
//                         className="form-control"
//                         value={formData.title}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     {/* Type */}
//                     <div className="col-md-6">
//                       <label className="form-label">Type</label>
//                       <input
//                         type="text"
//                         name="type"
//                         className="form-control"
//                         placeholder="order, wallet, system"
//                         value={formData.type}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     {/* Message */}
//                     <div className="col-md-12">
//                       <label className="form-label">Message *</label>
//                       <textarea
//                         name="message"
//                         className="form-control"
//                         rows="4"
//                         value={formData.message}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     {/* Reference ID */}
//                     <div className="col-md-6">
//                       <label className="form-label">Reference ID</label>
//                       <input
//                         type="text"
//                         name="reference_id"
//                         className="form-control"
//                         value={formData.reference_id}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     {/* Reference Model */}
//                     <div className="col-md-6">
//                       <label className="form-label">Reference Model</label>
//                       <input
//                         type="text"
//                         name="reference_model"
//                         className="form-control"
//                         placeholder="Order, Wallet"
//                         value={formData.reference_model}
//                         onChange={handleChange}
//                       />
//                     </div>

//                     {/* Priority */}
//                     <div className="col-md-6">
//                       <label className="form-label">Priority</label>
//                       <select
//                         name="priority"
//                         className="form-select"
//                         value={formData.priority}
//                         onChange={handleChange}
//                       >
//                         <option value="low">Low</option>
//                         <option value="normal">Normal</option>
//                         <option value="high">High</option>
//                       </select>
//                     </div>

//                     {/* Action URL */}
//                     <div className="col-md-6">
//                       <label className="form-label">Action URL</label>
//                       <input
//                         type="text"
//                         name="action_url"
//                         className="form-control"
//                         placeholder="/orders/123"
//                         value={formData.action_url}
//                         onChange={handleChange}
//                       />
//                     </div>

//                   </div>

//                   <div className="mt-4 text-end">
//                     <button type="submit" className="btn btn-primary">
//                       Send Notification
//                     </button>
//                   </div>

//                 </form>
//               </div>
//             </div>
//           </div>
//         </div>

//       </div>
//     </div>
//   );
// };


export const NotificationList = () => {
  const [notifications, setNotifications] = useState([]);

  // Send modal states
  const [showSendModal, setShowSendModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const [sendData, setSendData] = useState({
    role: "customer",
    user_id: ""
  });

  // Fetch notifications
  const fetchData = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_notification"
      );

      if (response.data.status === "true") {
        setNotifications(response.data.data || []);
      } else {
        toast.error("Failed to fetch notifications.");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching data.");
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // Delete notification
  const deleteNotification = async (id) => {
    if (!window.confirm("Are you sure you want to delete this notification?")) {
      return;
    }

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/delete_notification",
        { id }
      );

      if (response.data.status === true || response.data.success === "1") {
        toast.error("Notification deleted successfully!");
        setNotifications((prev) => prev.filter((item) => item.id !== id));
      } else {
        toast.error("Failed to delete notification.");
      }
    } catch {
      toast.error("Something went wrong while deleting notification.");
    }
  };

  // Open send modal
  const openSendModal = (notification) => {
    setSelectedNotification(notification);
    setSendData({ role: "customer", user_id: "" });
    setShowSendModal(true);
  };

  // Send existing notification
  const sendNotificationAgain = async () => {
    if (sendData.role === "single" && !sendData.user_id) {
      toast.error("User ID is required");
      return;
    }

    try {
      await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/send_notification",
        {
          notification_id: selectedNotification.id,
          receiver_type: sendData.role,
          user_id: sendData.role === "single" ? sendData.user_id : null
        }
      );

      toast.success("Notification sent successfully!");
      setShowSendModal(false);
    } catch {
      toast.error("Failed to send notification");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">All Notifications</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-item active">Notifications</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between align-items-center">
                <h4 className="card-title">All Notification Logs</h4>
                <Link
                  to="/notification-list-add"
                  className="btn btn-sm btn-primary"
                >
                  Create Notification
                </Link>
              </div>

              <div className="card-body p-0">
                <div className="table-responsive">
                  <table className="table align-middle table-hover table-centered mb-0">
                    <thead className="bg-light-subtle">
                      <tr>
                        <th>#</th>
                        <th>Title</th>
                        <th>Message</th>
                        <th>Type</th>
                        <th>Role</th>
                        <th>Status</th>
                        <th>Time</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {notifications.length > 0 ? (
                        notifications.map((item, index) => {
                          const isUnread = String(item.is_read) === "0";

                          return (
                            <tr key={item.id}>
                              <td>{index + 1}</td>
                              <td>{item.title}</td>
                              <td>{item.message}</td>
                              <td>
                                <span className="badge bg-info">
                                  {item.type}
                                </span>
                              </td>
                              <td className="text-capitalize">
                                {item.receiver_type}
                              </td>
                              <td>
                                <span
                                  className={`badge ${
                                    isUnread
                                      ? "bg-warning text-dark"
                                      : "bg-success"
                                  }`}
                                >
                                  {isUnread ? "Unread" : "Read"}
                                </span>
                              </td>
                              <td>{item.created_at}</td>
                              <td>
                                <div className="d-flex gap-2">
                                  <Link
                                    to={`/notification-list-view/${item.id}`}
                                  >
                                    <button className="btn btn-light btn-sm">
                                      <AiOutlineEye className="fs-5" />
                                    </button>
                                  </Link>

                                  <Link
                                    to={`/notification-list-edit/${item.id}`}
                                  >
                                    <button className="btn btn-light btn-sm">
                                      <i className="fa-solid fa-pencil"></i>
                                    </button>
                                  </Link>

                                  {(() => {
                                    const isAlreadySent =
                                      item.is_sent === "1" ||
                                      item.status === "sent" ||
                                      item.sent_at;

                                    return (
                                      <button
                                        onClick={() => openSendModal(item)}
                                        className={`btn btn-sm ${
                                          isAlreadySent
                                            ? "btn-warning"
                                            : "btn-soft-primary"
                                        }`}
                                      >
                                        {isAlreadySent ? "Resend" : "Send"}
                                      </button>
                                    );
                                  })()}

                                  <button
                                    onClick={() => deleteNotification(item.id)}
                                    className="btn btn-soft-danger btn-sm"
                                  >
                                    <i className="fa-solid fa-trash fs-18"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td
                            colSpan="8"
                            className="text-center text-muted py-4"
                          >
                            No notifications available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="card-footer text-end">
                <small className="text-muted">
                  Showing {notifications.length} entries
                </small>
              </div>
            </div>
          </div>
        </div>

        {/* Send Modal */}
        {showSendModal && (
          <div className="custom-modal-overlay">
            <div className="custom-modal">
              <div className="card shadow-lg border-0">
                {/* Header */}
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h5 className="mb-0">Send Notification</h5>
                  <button
                    className="btn-close"
                    onClick={() => setShowSendModal(false)}
                  />
                </div>

                {/* Body */}
                <div className="card-body">
                  <div className="mb-3">
                    <label className="form-label">Send To</label>
                    <select
                      className="form-select"
                      value={sendData.role}
                      onChange={(e) =>
                        setSendData({
                          ...sendData,
                          role: e.target.value
                        })
                      }
                    >
                      <option value="customer">All Customers</option>
                      <option value="seller">All_Sellers</option>
                      <option value="all">All_Users</option>
                      <option value="single">Single_User</option>
                    </select>
                  </div>

                  {sendData.role === "single" && (
                    <div className="mb-3">
                      <label className="form-label">User ID</label>
                      <input
                        className="form-control"
                        placeholder="Enter User ID"
                        value={sendData.user_id}
                        onChange={(e) =>
                          setSendData({
                            ...sendData,
                            user_id: e.target.value
                          })
                        }
                      />
                      <small className="text-muted">
                        Tip: You can find User IDs in the Customer List
                      </small>
                    </div>
                  )}
                </div>

                {/* Footer */}
                <div className="card-footer d-flex justify-content-end gap-2 bg-light">
                  <button
                    className="btn btn-light"
                    onClick={() => setShowSendModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={sendNotificationAgain}
                  >
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Footer */}
        <footer className="footer mt-4 text-center">
          <div className="container-fluid">© 2025 Notification System</div>
        </footer>
      </div>
    </div>
  );
};

export const AddNotification = () => {
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [sellers, setSellers] = useState([]);
  const [showUserSelector, setShowUserSelector] = useState(false);
  const [showSellerSelector, setShowSellerSelector] = useState(false);

  const [formData, setFormData] = useState({
    role: "All_User",
    user_id: "",
    seller_id:"",
    title: "",
    message: "",
    type: "",
    reference_id: "",
    reference_model: "",
    priority: "normal",
    action_url: ""
  });

  // ================= FETCH USERS =================
  const fetchCustomers = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/user_list"
      );
      if (response.data.status === true || response.data.status === "true") {
        setCustomers(response.data.data || []);
      }
    } catch (error) {
      console.error("Failed to fetch customers");
    }
  };

  const fetchSellers = async () => {
      try {
        const response = await fetch(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_seller_registration"
        );
        const result = await response.json();
  
        if (result.status && result.data) {
          setSellers(result.data);
        } 
      } catch (err) {
        console.log("Failed to fetch Sellers")
      } 
    };

  useEffect(() => {
    if (formData.role === "Single_User") {
      fetchCustomers();
    } else if(formData.role === "Single_Seller"){
      fetchSellers();
    }
  }, [formData.role]);
  

  // ================= HANDLE INPUT =================
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const selectUser = (userId) => {
    setFormData((prev) => ({ ...prev, user_id: userId }));
    setShowUserSelector(false);
  };

  const selectSeller = (sellerID) => {
    setFormData((prev) => ({ ...prev, seller_id: sellerID }));
    setShowSellerSelector(false);
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.title || !formData.message) {
    toast.error("Title and Message are required");
    return;
  }

  if (formData.role === "Single_User" && !formData.user_id) {
    toast.error("Please select a user");
    return;
  }

  if (formData.role === "Single_Seller" && !formData.seller_id) {
    toast.error("Please select a seller");
    return;
  }

  const allowedTypes = ["order", "payment", "offer", "system", "delivery"];

  const safeType = allowedTypes.includes(formData.type)
    ? formData.type
    : "system";

  const payload = {
    role: formData.role,
    title: formData.title,
    message: formData.message,
    type: safeType,
    reference_id: formData.reference_id || "",
    reference_model: formData.reference_model || "",
    priority: formData.priority || "normal",
    action_url: formData.action_url || "",

    receiver_type:
      formData.role === "All_User" || formData.role === "Single_User"
        ? "customer"
        : "seller",

    user_id:
      formData.role === "Single_User"
        ? formData.user_id
        : "0",

    seller_id:
      formData.role === "Single_Seller"
        ? formData.seller_id
        : "0",

    send_to:
      formData.role === "All_User" || formData.role === "All_Seller"
        ? "all"
        : "single",

    status: "pending",
    is_sent: "1"
  };

  console.log("FINAL PAYLOAD =>", payload);

  try {
    const response = await axios.post(
      "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_notification",
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    if (response.data.status === true || response.data.status === "true") {
      toast.success(response.data.message || "Notification sent successfully!");
      navigate("/notification-list");
    } else {
      toast.error(response.data.message || "Failed to add notification");
    }
  } catch (error) {
    toast.error(error.response?.data?.message || "Something went wrong");
  }
};


  // ================= UI =================
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h4 className="mb-3 fw-semibold">Add Notification</h4>

        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="row g-3">

                <div className="col-md-6">
                  <label className="form-label">Send To *</label>
                  <select
                    name="role"
                    className="form-select"
                    value={formData.role}
                    onChange={handleChange}
                  >
                    <option value="All_User">All Users</option>
                    <option value="All_Seller">All Sellers</option>
                    <option value="Single_User">Single User</option>
                    <option value="Single_Seller">Single Seller</option>
                  </select>
                </div>

                {formData.role === "Single_User" && (
                  <div className="col-md-6">
                    <label className="form-label">User ID *</label>
                    <div className="input-group">
                      <input
                        type="text"
                        name="user_id"
                        className="form-control"
                        value={formData.user_id}
                        onChange={handleChange}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowUserSelector(true)}
                      >
                        Select
                      </button>
                    </div>
                  </div>
                )}

                {formData.role === "Single_Seller" && (
                  <div className="col-md-6">
                    <label className="form-label">Seller ID *</label>
                    <div className="input-group">
                      <input
                        type="text"
                        name="seller_id"
                        className="form-control"
                        value={formData.seller_id}
                        onChange={handleChange}
                      />
                      <button
                        type="button"
                        className="btn btn-outline-secondary"
                        onClick={() => setShowSellerSelector(true)}
                      >
                        Select
                      </button>
                    </div>
                  </div>
                )}

                <div className="col-md-6">
                  <label className="form-label">Title *</label>
                  <input
                    type="text"
                    name="title"
                    className="form-control"
                    value={formData.title}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Type</label>
                  <select
                    name="type"
                    className="form-select"
                    value={formData.type}
                    onChange={handleChange}
                  >
                    <option value="">Select Type</option>
                    <option value="system">System</option>
                    <option value="order">Order</option>
                    <option value="payment">Payment</option>
                    <option value="offer">Offer</option>
                    <option value="delivery">Delivery</option>
                  </select>

                </div>

                <div className="col-md-6">
                  <label className="form-label">Message *</label>
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    value={formData.message}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Reference ID</label>
                  <input
                    type="text"
                    name="reference_id"
                    className="form-control"
                    value={formData.reference_id}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Reference Model</label>
                  <input
                    type="text"
                    name="reference_model"
                    className="form-control"
                    value={formData.reference_model}
                    onChange={handleChange}
                  />
                </div>

                <div className="col-md-6">
                  <label className="form-label">Priority</label>
                  <select
                    name="priority"
                    className="form-select"
                    value={formData.priority}
                    onChange={handleChange}
                  >
                    <option value="low">Low</option>
                    <option value="normal">Normal</option>
                    <option value="high">High</option>
                  </select>
                </div>

                <div className="col-md-6">
                  <label className="form-label">Action URL</label>
                  <input
                    type="text"
                    name="action_url"
                    className="form-control"
                    value={formData.action_url}
                    onChange={handleChange}
                  />
                </div>

              </div>

              <div className="mt-4 text-end">
                <button type="submit" className="btn btn-primary">
                  Send Notification
                </button>
              </div>
            </form>
          </div>
        </div>

        {/* USER SELECTOR MODAL */}
        {showUserSelector && (
            <div className="custom-modal-overlay">
              <div className="custom-modal seller-modal">
                <div className="modal-content seller-modal-content">

                  <div className="card h-100 mb-0">

                    <div className="card-header d-flex justify-content-between align-items-center">
                      <h5 className="mb-0">Select User</h5>
                      <button
                        className="btn-close"
                        onClick={() => setShowUserSelector(false)}
                      />
                    </div>

                    {/* SAME SCROLL WRAPPER */}
                    <div className="card-body p-0 seller-table-wrapper">
                      <table className="table table-hover mb-0">
                        <thead className="table-light">
                          <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Email</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {customers.map((c) => (
                            <tr key={c.user_id}>
                              <td>{c.user_id}</td>
                              <td>{c.name}</td>
                              <td>{c.email}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-primary"
                                  onClick={() => selectUser(c.user_id)}
                                >
                                  Select
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          )}



        {/* Seller SELECTOR MODAL */}
        {showSellerSelector && (
  <div className="custom-modal-overlay">
    <div className="custom-modal seller-modal">
      <div className="modal-content seller-modal-content">

        <div className="card h-100 mb-0">

          <div className="card-header d-flex justify-content-between align-items-center">
            <h5 className="mb-0">Select Seller</h5>
            <button
              className="btn-close"
              onClick={() => setShowSellerSelector(false)}
            />
          </div>

          {/* 🔥 SCROLL AREA */}
          <div className="card-body p-0 seller-table-wrapper">
            <table className="table table-hover mb-0">
              <thead className="table-light sticky-top">
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {sellers.map((c) => (
                  <tr key={c.seller_id}>
                    <td>{c.seller_id}</td>
                    <td>{c.business_name}</td>
                    <td>{c.email}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => selectSeller(c.seller_id)}
                      >
                        Select
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </div>
  </div>
)}


      </div>
    </div>
  );
};

export const EditNotification = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [formData, setFormData] = useState({
    role: "customer", // customer | seller | all | single
    user_id: "",
    title: "",
    message: "",
    type: "",
    reference_id: "",
    reference_model: "",
    priority: "normal",
    action_url: ""
  });

  // Fetch notification by ID
  const fetchNotification = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_notification",
        { params: { id } }
      );

      if (response.data.status === true) {
        const data = response.data.data;

        setFormData({
          role: data.user_id ? "single" : data.receiver_type,
          user_id: data.user_id || "",
          title: data.title || "",
          message: data.message || "",
          type: data.type || "",
          reference_id: data.reference_id || "",
          reference_model: data.reference_model || "",
          priority: data.priority || "normal",
          action_url: data.action_url || ""
        });
      } else {
        toast.error("Failed to fetch notification");
      }
    } catch (error) {
      toast.error("Something went wrong while fetching data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchNotification();
  }, [id]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // Update notification
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.message) {
      toast.error("Please fill required fields");
      return;
    }

    if (formData.role === "single" && !formData.user_id) {
      toast.error("User ID is required for Single_User");
      return;
    }

    const payload = {
      id,
      title: formData.title,
      message: formData.message,
      type: formData.type,
      reference_id: formData.reference_id,
      reference_model: formData.reference_model,
      priority: formData.priority,
      action_url: formData.action_url,
      receiver_type: formData.role,
      user_id:
        formData.role === "single"
          ? formData.user_id
          : null
    };

    try {
      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_notification",
        payload
      );

      if (response.data.status === true || response.data.success === "1") {
        toast.success("Notification updated successfully!");
        navigate("/notification-list");
      } else {
        toast.error("Failed to update notification");
      }
    } catch (error) {
      toast.error("Something went wrong while updating notification");
    }
  };

  // Loading UI
  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid text-center py-5">
          <p className="text-muted">Loading notification...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Edit Notification</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-user">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-user">
                  <a href="#">Notifications</a>
                </li>
                <li className="breadcrumb-user active">Edit</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Update Notification</h4>
              </div>

              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">

                    {/* Send To */}
                    <div className="col-md-6">
                      <label className="form-label">Send To *</label>
                      <select
                        name="role"
                        className="form-select"
                        value={formData.role}
                        onChange={handleChange}
                      >
                        <option value="customer">All Customers</option>
                        <option value="seller">All_Sellers</option>
                        <option value="all">All_Users</option>
                        <option value="single">Single_User</option>
                      </select>
                    </div>

                    {/* User ID */}
                    {formData.role === "single" && (
                      <div className="col-md-6">
                        <label className="form-label">User ID *</label>
                        <input
                          type="text"
                          name="user_id"
                          className="form-control"
                          value={formData.user_id}
                          onChange={handleChange}
                        />
                      </div>
                    )}

                    {/* Title */}
                    <div className="col-md-6">
                      <label className="form-label">Title *</label>
                      <input
                        type="text"
                        name="title"
                        className="form-control"
                        value={formData.title}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Type */}
                    <div className="col-md-6">
                      <label className="form-label">Type</label>
                      <input
                        type="text"
                        name="type"
                        className="form-control"
                        value={formData.type}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Message */}
                    <div className="col-md-12">
                      <label className="form-label">Message *</label>
                      <textarea
                        name="message"
                        className="form-control"
                        rows="4"
                        value={formData.message}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Reference ID */}
                    <div className="col-md-6">
                      <label className="form-label">Reference ID</label>
                      <input
                        type="text"
                        name="reference_id"
                        className="form-control"
                        value={formData.reference_id}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Reference Model */}
                    <div className="col-md-6">
                      <label className="form-label">Reference Model</label>
                      <input
                        type="text"
                        name="reference_model"
                        className="form-control"
                        value={formData.reference_model}
                        onChange={handleChange}
                      />
                    </div>

                    {/* Priority */}
                    <div className="col-md-6">
                      <label className="form-label">Priority</label>
                      <select
                        name="priority"
                        className="form-select"
                        value={formData.priority}
                        onChange={handleChange}
                      >
                        <option value="low">Low</option>
                        <option value="normal">Normal</option>
                        <option value="high">High</option>
                      </select>
                    </div>

                    {/* Action URL */}
                    <div className="col-md-6">
                      <label className="form-label">Action URL</label>
                      <input
                        type="text"
                        name="action_url"
                        className="form-control"
                        value={formData.action_url}
                        onChange={handleChange}
                      />
                    </div>

                  </div>

                  <div className="mt-4 text-end">
                    <button type="submit" className="btn btn-primary">
                      Update Notification
                    </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};


export const ViewNotification = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [notification, setNotification] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch notification by ID
  const fetchNotification = async () => {
    try {
      const response = await axios.get(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/get_by_id_notification",
        { params: { id } }
      );

      if (response.data.status === true) {
        setNotification(response.data.data);
      } else {
        toast.error("Failed to fetch notification");
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) fetchNotification();
  }, [id]);

  // Loading state
  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid text-center py-5">
          <p className="text-muted">Loading notification...</p>
        </div>
      </div>
    );
  }

  // Not found state
  if (!notification) {
    return (
      <div className="page-content">
        <div className="container-fluid text-center py-5">
          <p className="text-danger">Notification not found</p>
        </div>
      </div>
    );
  }

  const isUnread = String(notification.is_read) === "0";

  return (
    <div className="page-content">
      <div className="container-fluid">

        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">View Notification</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-user">
                  <a href="#">Dashboard</a>
                </li>
                <li className="breadcrumb-user">
                  <a href="#">Notifications</a>
                </li>
                <li className="breadcrumb-user active">View</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Details Card */}
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header d-flex justify-content-between">
                <h4 className="card-title">Notification Details</h4>
                <button
                  onClick={() => navigate(-1)}
                  className="btn btn-light btn-sm"
                >
                  Back
                </button>
              </div>

              <div className="card-body">
                <div className="row g-3">

                  {/* Receiver Type */}
                  <div className="col-md-6">
                    <label className="form-label">Sent To</label>
                    <input
                      className="form-control text-capitalize"
                      value={notification.receiver_type}
                      disabled
                    />
                  </div>

                  {/* User ID */}
                  <div className="col-md-6">
                    <label className="form-label">User ID</label>
                    <input
                      className="form-control"
                      value={notification.user_id || "All_Users"}
                      disabled
                    />
                  </div>

                  {/* Title */}
                  <div className="col-md-6">
                    <label className="form-label">Title</label>
                    <input
                      className="form-control"
                      value={notification.title}
                      disabled
                    />
                  </div>

                  {/* Type */}
                  <div className="col-md-6">
                    <label className="form-label">Type</label>
                    <input
                      className="form-control"
                      value={notification.type || "-"}
                      disabled
                    />
                  </div>

                  {/* Message */}
                  <div className="col-md-12">
                    <label className="form-label">Message</label>
                    <textarea
                      className="form-control"
                      rows="4"
                      value={notification.message}
                      disabled
                    />
                  </div>

                  {/* Reference ID */}
                  <div className="col-md-4">
                    <label className="form-label">Reference ID</label>
                    <input
                      className="form-control"
                      value={notification.reference_id || "-"}
                      disabled
                    />
                  </div>

                  {/* Reference Model */}
                  <div className="col-md-4">
                    <label className="form-label">Reference Model</label>
                    <input
                      className="form-control"
                      value={notification.reference_model || "-"}
                      disabled
                    />
                  </div>

                  {/* Priority */}
                  <div className="col-md-4">
                    <label className="form-label">Priority</label>
                    <input
                      className="form-control text-capitalize"
                      value={notification.priority || "normal"}
                      disabled
                    />
                  </div>

                  {/* Status */}
                  <div className="col-md-6">
                    <label className="form-label">Status</label>
                    <span
                      className={`form-control ${
                        isUnread
                          ? "bg-warning text-dark"
                          : "bg-success text-white"
                      }`}
                    >
                      {isUnread ? "Unread" : "Read"}
                    </span>
                  </div>

                  {/* Created At */}
                  <div className="col-md-6">
                    <label className="form-label">Created At</label>
                    <input
                      className="form-control"
                      value={notification.created_at}
                      disabled
                    />
                  </div>

                  {/* Action URL */}
                  <div className="col-md-12">
                    <label className="form-label">Action URL</label>
                    <input
                      className="form-control"
                      value={notification.action_url || "-"}
                      disabled
                    />
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};